import reducer from "./reducers";

import * as categoryOperations from "./operations";

export { categoryOperations };

export default reducer;